import React from 'react'
import Button from '../button'
import styled, { css } from 'styled-components'

const Serv = styled.div`
  text-align: left;
  margin-bottom: 1rem;
  ${props =>
    props.mobile &&
    css`
      text-align: left;
    `};
`
const Service = styled.div`
  padding: 0.4rem 0.4rem 0.4rem 0;
  height: 2rem;
  float: left;
`
const Services = ({ pop, mobile }) => {
  return (
    <Serv mobile={mobile}>
      {pop.internet > 0 && (
        <Service>
          <Button title="IP" href="https://telxius.com/en/cable-business/ip/internet-transit/" type="ip" />
        </Service>
      )}

      {pop.capacity > 0 && (
        <Service>
          <Button title="Capacity" href="https://telxius.com/en/cable-business/capacity/global-carrier-ethernet/" type="capacity" />
        </Service>
      )}

      {pop.colocation > 0 && (
        <Service>
          <Button title="Colocation" href="https://telxius.com/en/cable-business/colocation/colocation/" type="colocation" />
        </Service>
      )}
    </Serv>
  )
}

const CardPop = ({ pop, mobile }) => {
  return <>{pop.internet || pop.colocation || pop.capacity ? <Services pop={pop} mobile={mobile} /> : <></>}</>
}
export default CardPop
